import { createContext, useContext, useState } from 'react';

type QuoteDrawerContextType = {
  isOpen: boolean;
  serviceName: string;
  openDrawer: () => void;
  closeDrawer: () => void;
};

const QuoteDrawerContext = createContext<QuoteDrawerContextType>({
  isOpen: false,
  serviceName: '',
  openDrawer: () => {},
  closeDrawer: () => {},
});

export function QuoteDrawerProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [serviceName, setServiceName] = useState('');

  const openDrawer = () => {
    setIsOpen(true);
  };

  const closeDrawer = () => {
    setIsOpen(false);
  };

  return (
    <QuoteDrawerContext.Provider value={{ isOpen, serviceName, openDrawer, closeDrawer }}>
      {children}
    </QuoteDrawerContext.Provider>
  );
}

export function useQuoteDrawer() {
  return useContext(QuoteDrawerContext);
}
